import React, { useState, useEffect } from "react";
import CheckIcon from "@mui/icons-material/Check";
import Avatar from "@mui/material/Avatar";

import CloseIcon from "@mui/icons-material/Close";

const CardClientTest = ({
  appointment,
  checkCard,
  isSideBarOpen,
  handleToggleSidebar,
  clientScheduler,
  isPastDayAndHour,
  setClientActive,
  activeClientInformation,
  activeClientId,
  activeReschedule,
  setActiveClientInformation,
  setUsersPopuop,
}) => {
  const [existClient, setExistClient] = useState(false);
  const [existClientNoReschedule, setExistClientNoReschedule] = useState(false);
  const [selectedClient, setSelectedClient] = useState(null);
  useEffect(() => {
    setExistClientNoReschedule(false);
    if (appointment && activeReschedule) {
      const client = appointment.bookings_client.find(
        (booking_client) => activeClientId === booking_client.client_id
      );

      if (client) {
        setExistClient(true);
        setSelectedClient(client);
      } else {
        setExistClient(false);
        setSelectedClient(null);
      }
    }
    if (appointment && activeClientInformation != null) {
      let client = [];
      if (activeClientInformation.client_id != null) {
        client = appointment.bookings_client.find(
          (booking_client) =>
            activeClientInformation.client_id === booking_client.client_id
        );
      } else {
        client = appointment.bookings_client.find(
          (booking_client) =>
            activeClientInformation.id === booking_client.client_id
        );
      }

      if (client) {
        console.log(client, "ovo je klijent");
        setExistClientNoReschedule(true);
      }
    }
  }, [appointment, activeClientId, activeReschedule]);

  const renderActiveRescheduleCards = () => {
    if (!appointment) {
      return;
    }
    if (!existClient) {
      return (
        <div
          className="free-space"
          onClick={() =>
            isPastDayAndHour || appointment.free_bookings == 0
              ? null
              : checkCard(appointment.start, appointment.id, appointment)
          }
          style={{
            color: "#404040",

            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontWeight: "700",
            borderRadius: "7px",
            boxShadow: appointment.checked
              ? "0px 4px 8px rgba(0, 0, 0, 0.25)"
              : "",
            width: "100%",
            backgroundColor:
              isPastDayAndHour || appointment.free_bookings == 0
                ? "rgb(242, 242, 242)"
                : !appointment.checked
                ? "rgb(249, 249, 249)"
                : "rgba(255, 142, 139, 1)",
          }}
        >
          {appointment.checked ? (
            <CheckIcon style={{ color: "rgba(64, 64, 64, 1)" }} />
          ) : (
            <span
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {appointment.used_bookings} / {appointment.max_bookings}
            </span>
          )}
        </div>
      );
    } else {
      return (
        <div
          onClick={() =>
            appointment.bookings_client?.[0]?.status === "noshow"
              ? null
              : !isPastDayAndHour
              ? checkCard(appointment.start, appointment.id, appointment)
              : null
          }
          className="exist-client-card"
          style={{
            alignItems: "center",
            fontSize: "10px",
            borderRadius: "7px",
            width: "100%",
            display: "flex",
            justifyContent: "center",
            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.25)",

            color: "black",
            backgroundColor:
              appointment.bookings_client?.[0]?.status === "noshow"
                ? "red"
                : isPastDayAndHour
                ? "rgb(242, 242, 242)"
                : appointment.checked
                ? "rgba(255, 205, 178, 1)"
                : " rgba(208, 238, 198, 1) ",
            width: "100%",
            height: "100%",
          }}
        >
          {appointment.checked ? (
            <CloseIcon
              style={{ color: "rgba(255, 142, 139, 1)" }}
              sx={{ fontSize: 25 }}
            />
          ) : (
            <img
              style={{ width: "20px", height: "20px" }}
              src={"/weightlifter.png"}
              alt="Activity"
            />
          )}
        </div>
      );
    }
  };

  return (
    <div style={{ display: "flex" }}>
      <div className={"stacked-avataras-reschedule"}>
        {renderActiveRescheduleCards()}
      </div>
    </div>
  );
};

export default CardClientTest;
